import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import BackMethods from "../../back_component/BackMethods";
import ProcessComplaintModal from "./ProcessComplaintModal";
import {
    FaArrowRight, FaCalendarAlt, FaPhone, FaStore, FaMapMarkerAlt,
    FaClipboardCheck, FaImage, FaUserShield, FaClock, FaTimes, FaExpandAlt, FaTools, FaReply
} from "react-icons/fa";

export default function ComplaintDetailsPage() {
    const location = useLocation();
    const navigate = useNavigate();
    const { backEnd_request } = BackMethods();

    const [loading, setLoading] = useState(true);
    const [complaint, setComplaint] = useState(null);
    const [selectedImg, setSelectedImg] = useState(null);
    const [showProcessModal, setShowProcessModal] = useState(false);
    const [processLoading, setProcessLoading] = useState(false);

    const fetchDetails = async () => {
        const uid = new URLSearchParams(location.search).get("uid");
        if (!uid) return;
        try {
            const res = await backEnd_request.get(`/public/staff/complaints/${uid}`);
            console.log(res)

            setComplaint(res.data);
        } catch (err) { console.error(err); }
        finally { setLoading(false); }
    };

    useEffect(() => { fetchDetails(); }, [location.search]);

    const handleProcess = async (formData) => {
        setProcessLoading(true);
        try {
            await backEnd_request.post(`/public/complaints/${complaint.complaintUid}/process`, {
                response: formData.response,
                markPublic: formData.markPublic
            });
            setShowProcessModal(false);
            fetchDetails();
        } catch (err) {
            console.log(err)
            alert("حدث خطأ أثناء معالجة الشكوى");
        }
        finally { setProcessLoading(false); }
    };

    if (loading) return <div className="text-center py-5 mt-5"><div className="spinner-border text-primary shadow-sm"></div></div>;
    if (!complaint) return null;

    return (
        <div className="bg-light min-vh-100 py-4" dir="rtl">
            <div className="container shadow-container">
                {/* Header Section */}
                <div className="d-flex justify-content-between align-items-center mb-4 bg-white p-3 rounded-4 shadow-sm border-end border-primary border-5">
                    <div>
                        <h4 className="fw-bold mb-0 text-dark">تفاصيل ملف الشكوى</h4>
                        <small className="text-muted">مراجعة البيانات واتخاذ الإجراءات اللازمة</small>
                    </div>
                    <div className="d-flex gap-2">
                        <button
                            className="btn btn-primary rounded-pill px-4 shadow-sm fw-bold border-0"
                            onClick={() =>
                                navigate("/admin/inspection-mission/create", {
                                    state: {
                                        fieldUID: complaint.establishment.fieldUID,
                                        establishmentName: complaint.establishment.name,
                                        complaintUid: complaint.complaintUid

                                    }
                                }
                                )}
                        >
                            <FaTools className="ms-2" /> إنشاء مهمة
                        </button>
                        {!complaint.isProcessed && (
                            <button className="btn btn-success rounded-pill px-4 shadow-sm fw-bold border-0" onClick={() => setShowProcessModal(true)}>
                                <FaTools className="ms-2" /> معالجة الشكوى
                            </button>
                        )}
                        <button onClick={() => navigate(-1)} className="btn btn-white shadow-sm rounded-pill px-4 border">
                            <FaArrowRight className="ms-2" /> العودة للسجل
                        </button>
                    </div>
                </div>

                <div className="row g-4">
                    <div className="col-lg-8">
                        {/* نص الشكوى - مصمم ليتناسب مع النصوص الطويلة (500 محرف) */}
                        <div className="card border-0 shadow-sm rounded-4 mb-4 overflow-hidden">
                            <div className="card-header bg-white py-3 border-bottom d-flex align-items-center">
                                <FaClipboardCheck className="text-primary ms-2" />
                                <h5 className="mb-0 fw-bold text-dark">محتوى البلاغ</h5>
                            </div>
                            <div className="card-body p-4 bg-white">
                                <blockquote className="complaint-quote p-4 rounded-4 position-relative">
                                    <p className="fs-5 text-dark lh-lg mb-0" style={{ whiteSpace: 'pre-line', textAlign: 'justify' }}>
                                        {complaint.complaintText}
                                    </p>
                                </blockquote>
                                <div className="d-flex flex-wrap gap-4 mt-3 pt-3 border-top text-muted small">
                                    <span><FaCalendarAlt className="ms-1 text-primary" /> تاريخ التقديم: <strong>{new Date(complaint.createdAtUtc).toLocaleString('ar-SY')}</strong></span>
                                    {complaint.isProcessed && (
                                        <span className="text-success"><FaClipboardCheck className="ms-1" /> تاريخ المعالجة: <strong>{new Date(complaint.processedAtUtc).toLocaleString('ar-SY')}</strong></span>
                                    )}
                                </div>
                            </div>
                        </div>

                        {/* رد الموظف (يظهر فقط عند المعالجة) */}
                        {complaint.isProcessed && (
                            <div className="card border-0 shadow-sm rounded-4 mb-4 border-top border-success border-5">
                                <div className="card-header bg-white py-3 border-bottom d-flex align-items-center">
                                    <FaReply className="text-success ms-2" />
                                    <h5 className="mb-0 fw-bold text-dark">المعالجة</h5>
                                </div>
                                <div className="card-body p-4">
                                    <div className="p-3 rounded-4 bg-success-subtle border border-success border-opacity-10 text-dark lh-base">
                                        {complaint.staffResponse || "تم إغلاق الشكوى بنجاح."}
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* الصور والمرفقات */}
                        <div className="card border-0 shadow-sm rounded-4">
                            <div className="card-header bg-white py-3 border-bottom">
                                <h5 className="mb-0 fw-bold"><FaImage className="ms-2 text-info" /> المرفقات المرئية ({complaint.photos?.length || 0})</h5>
                            </div>
                            <div className="card-body p-4">
                                <div className="row g-3">
                                    {complaint.photos?.map((photo, i) => (
                                        <div key={i} className="col-md-4">
                                            <div className="image-card shadow-sm rounded-4 overflow-hidden" onClick={() => setSelectedImg(photo.url)}>
                                                <img src={photo.url} alt="Evidence" className="img-fluid" />
                                                <div className="image-overlay"><FaExpandAlt /></div>
                                            </div>
                                        </div>
                                    ))}
                                    {(!complaint.photos || complaint.photos.length === 0) && (
                                        <div className="text-center py-5 text-muted bg-light rounded-4 border border-dashed">
                                            <FaImage size={30} className="mb-2 opacity-25" /><br />لا توجد صور مرفقة
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4">
                        {/* بطاقة الحالة والمنشأة بشكل مدمج ومتناسق */}
                        <div className={`card border-0 shadow-sm rounded-4 mb-4 text-center text-white p-4 ${complaint.isProcessed ? 'bg-success' : 'bg-warning'}`}>
                            {complaint.isProcessed ? <FaClipboardCheck size={40} className="mb-3" /> : <FaClock size={40} className="mb-3" />}
                            <h4 className="fw-bold mb-1">{complaint.isProcessed ? 'تمت المعالجة' : 'قيد المراجعة'}</h4>
                            <small className="opacity-75">{complaint.isProcessed ? 'تم إغلاق هذا الملف' : 'بانتظار الإجراء الإداري'}</small>
                        </div>

                        <div className="card border-0 shadow-sm rounded-4 mb-4">
                            <div className="card-body p-4">
                                <h6 className="text-muted small fw-bold mb-4 text-center border-bottom pb-2">تفاصيل الفعالية</h6>
                                <div className="text-center">
                                    <div className="bg-primary-subtle p-3 rounded-circle d-inline-block mb-3">
                                        <FaStore className="text-primary fs-3" />
                                    </div>
                                    <h5 className="fw-bold text-dark">{complaint.establishment?.name}</h5>
                                    <p className="text-muted small mb-4">
                                        <FaMapMarkerAlt className="ms-1" /> {complaint.establishment?.governorate}، {complaint.establishment?.city}
                                    </p>
                                    <button className="btn btn-outline-primary w-100 rounded-pill fw-bold btn-sm py-2 shadow-sm" onClick={() => navigate(`/admin/establishments/${complaint.establishment?.fieldUID}`)}>
                                        فتح ملف المنشأة
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className="card border-0 shadow-sm rounded-4 border-end border-danger border-4">
                            <div className="card-body p-4">
                                <h6 className="text-muted small fw-bold mb-3">بيانات التواصل (سرية)</h6>
                                <div className="d-flex align-items-center p-3 bg-light rounded-4 shadow-inner mb-3">
                                    <FaPhone className="text-primary ms-3 fs-5" />
                                    <div>
                                        <div className="text-muted x-small">رقم هاتف المشتكي</div>
                                        <div className="fw-bold fs-5 tracking-wider" dir="ltr">{complaint.submitterPhone}</div>
                                    </div>
                                </div>
                                <div className="alert alert-secondary py-2 small border-0 mb-0 d-flex gap-2 align-items-center">
                                    <FaUserShield className="text-danger" />
                                    <span style={{ fontSize: '0.75rem' }}>بيانات المشتكي تظهر للموظفين المختصين فقط.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Lightbox Modal */}
            {selectedImg && (
                <div className="lightbox-overlay" onClick={() => setSelectedImg(null)}>
                    <div className="lightbox-content" onClick={e => e.stopPropagation()}>
                        <button className="close-btn" onClick={() => setSelectedImg(null)}><FaTimes /></button>
                        <img src={selectedImg} alt="Evidence" className="img-fluid rounded-4 shadow-lg" />
                    </div>
                </div>
            )}

            <ProcessComplaintModal
                isOpen={showProcessModal}
                onClose={() => setShowProcessModal(false)}
                onConfirm={handleProcess}
                loading={processLoading}
            />

            <style>{`
                .shadow-container { animation: fadeIn 0.5s ease; }
                .complaint-quote { background: #fdfdfd; border: 1px solid #f0f0f0; }
                .complaint-quote::before { content: '"'; position: absolute; top: -10px; right: 20px; font-size: 80px; color: #007bff; opacity: 0.1; font-family: serif; }
                .image-card { cursor: pointer; position: relative; height: 180px; transition: 0.3s; }
                .image-card img { width: 100%; height: 100%; object-fit: cover; }
                .image-overlay { position: absolute; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.5); display: flex; align-items: center; justify-content: center; color: white; font-size: 1.8rem; opacity: 0; transition: 0.3s; }
                .image-card:hover .image-overlay { opacity: 1; }
                .image-card:hover { transform: translateY(-5px); }
                .lightbox-overlay { position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.92); z-index: 10001; display: flex; align-items: center; justify-content: center; padding: 20px; backdrop-filter: blur(5px); }
                .lightbox-content { max-width: 80%; max-height: 80vh; position: relative; }
                .close-btn { position: absolute; top: -50px; left: 0; background: none; border: none; color: white; font-size: 2rem; cursor: pointer; }
                .x-small { font-size: 0.7rem; }
                .bg-success-subtle { background-color: #e6f4ea !important; }
                .tracking-wider { letter-spacing: 1px; }
                @keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
            `}</style>
        </div>
    );
}